import {Component, ElementRef, OnInit, QueryList, Renderer2, ViewChildren} from '@angular/core';
import {first} from "rxjs";
import {MatTableDataSource} from "@angular/material/table";
import { toggleLoading } from "../../../redux";
import {DealService, SyndicationService} from "../../services";
import {ActivatedRoute, Router} from "@angular/router";
import {Store} from "@ngrx/store";
import {ToastrService} from "ngx-toastr";
import {MatDialog} from "@angular/material/dialog";
import {LockInModalComponent} from "../lock-in-modal/lock-in-modal.component";
import {NotesModalComponent} from "../notes-modal/notes-modal.component";
import {
  ConfirmationModalComponent,
  DeleteConfirmationModalComponent, PromptModalComponent
} from "../../../shared/components";
import {UtilService} from "../../../shared/services";
import {ModalSize} from "../../../shared/services/util/util.service";
import {IDealSyndication} from "../../models";
import {
  ISubDocFieldsResponse,
  ISyndicationItem,
  ISyndicationSubdoc
} from "../../models/syndication";
import {SubdocService} from "../../services/subdoc/subdoc.service";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {
  DealSubscriptionSubdocEditModalComponent,
  DealSubscriptionSubdocFormModalComponent,
  DealSubscriptionSubdocModalComponent,
  IndicateInterestModalComponent
} from "../index";
import {LookupService } from "../../../../services";
import { AllocationEditModalComponent } from '../allocation-edit-modal/allocation-edit-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { MatExpansionPanel } from '@angular/material/expansion';


@Component({
  selector: 'app-syndication',
  templateUrl: './syndication.component.html',
  styleUrls: ['./syndication.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed,void', style({height: '0px', minHeight: '0'})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class SyndicationComponent implements OnInit {

  // @ViewChildren(MatExpansionPanel) panels!: QueryList<MatExpansionPanel>;
  dataSource: MatTableDataSource<ISyndicationItem> = new MatTableDataSource();
  // matchesColsToDisplay = ['businessUnit', 'ioi', 'allocation', 'notes', 'status', 'date', 'actions'];
  matchesColsToDisplay = ['businessUnit', 'ioi', 'allocation', 'notes', 'status', 'date', 'actions', 'subdocs'];
  subdocCols = ['amount', 'status', 'created', 'actions'];
  subDocsOnlyTableColumns = ['investor', 'amount', 'status', 'date', 'actions'];
  showSubDocsTableOnly: boolean = false;
  subDocsDataSource: MatTableDataSource<ISyndicationSubdoc> = new MatTableDataSource();
  syndication!: IDealSyndication;

  highlightId : string = '';

  constructor(
    private syndicationService: SyndicationService,
    private subDocService: SubdocService,
    private activatedRoute: ActivatedRoute,
    private store: Store,
    private toastrService: ToastrService,
    public dialog: MatDialog,
    public util: UtilService,
    public lookupService: LookupService,
    private renderer: Renderer2, private elRef: ElementRef
  ) {

    this.getSyndication();
  }

  ngOnInit() {
  }

  getSyndication() {
    console.log("Fetching Syndication...");
    this.syndicationService.getSyndication().subscribe({
      next: (result: IDealSyndication) => { 
        console.log("Deal Syndication", result);
        result.syndicationItems.map(x => x.expanded = false)
        this.syndication = result;
        this.dataSource.data = this.syndication.syndicationItems;

        // highlight any syndication or subdoc rows via query param
        var syndicationId = this.activatedRoute.snapshot.queryParamMap.get("syndicationId");
        var subDocId = this.activatedRoute.snapshot.queryParamMap.get("subDocId");

        var subdocs : ISyndicationSubdoc[] = this.syndication.syndicationItems.flatMap(x => x.subDocs);
        subdocs.sort((a, b) => {
          let dateA = new Date(a.created);
          let dateB = new Date(b.created);
          return dateB.getTime() - dateA.getTime();
        });
        this.subDocsDataSource.data = subdocs;
        // this.subDocsDataSource.data = result.syndicationItems.flatMap(x => x.subDocs);

        // // test
        // this.fillSubdoc(this.subDocsDataSource.data[0], true);
        // return;

        if (!!syndicationId) {
          setTimeout(() => {
            const row = this.elRef.nativeElement.querySelector(`#syndication-${syndicationId}`);
            if (row) {
              this.renderer.setStyle(row, 'background-color', '#ffeac3');
            }
          }, 500)
        }

        if (!!subDocId) {
          // open the syndication row & highlight the subdoc Id
          this.showSubDocsTableOnly = true;
          setTimeout(() => {
            const row = this.elRef.nativeElement.querySelector(`#subdoc-${subDocId}`);
            if (row) {
              this.renderer.setStyle(row, 'background-color', '#ffeac3');
            }
          }, 500)
        }
      }
    });
  }

  changeLockStatus(locked: boolean) {
    this.dialog.open(LockInModalComponent, {
      height: 'auto',
      width: this.util.getModalWidth(ModalSize.SMALL),
      maxWidth: '800px',
      data: { locked },
      disableClose: true
    })
    .afterClosed().subscribe(result => {
      console.log("Dialog output:", result);
      if (result === true) {

        let payload = {
          isLocked: locked,
          silentPoolLockChange: true // this is for backwards compatability
        };
    
        this.store.dispatch(toggleLoading({loading: true}));
        this.syndicationService.changeLockStatus(payload).subscribe({
          next: (res: any) => {
            // this.matchesSource = new MatTableDataSource(this.syndication.syndicationItems);
            this.syndication.issuerPoolIsLocked = locked;
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.success(locked ? "Pool Locked!" : "Pool Unlocked!", $localize`:@@companyName:Rondeivu`);
          }, error: err => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.error("Unable to change lock status!", $localize`:@@companyName:Rondeivu`);
          }
        });

      }
    });
  }

  editAllocationModal(element: ISyndicationItem) {
    console.log("Edit Allocation", element)
    this.dialog.open(AllocationEditModalComponent, {
      height: 'auto',
      minWidth: '600px',
      data: element,
      disableClose: true
    })
    .afterClosed().subscribe(result => {
      console.log("result", result);
      if (!!result) {
        // this.getSyndication();
        this.syndicationService.updateSyndication(result).subscribe({
          next: () => {
            this.toastrService.success("Operation Successful!")
            this.getSyndication();
          },
          error: (err: HttpErrorResponse) => {
            this.toastrService.error("Could not update entry");
          }
        })

      }
    });
  }

  delete(element: any) {
    const delRef = this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      data: element,
      disableClose: true
    });

    delRef.afterClosed().subscribe(result => {
      // console.log("Dialog output:", result);
      if (!!result) {
        this.store.dispatch(toggleLoading({loading: true}));
        this.syndicationService.deleteSyndication(result).subscribe({
          next: (res: any) => {
            //replace in list
            if (!!result) {
              let idx = -1;
              for (let i = 0; i <= this.syndication.syndicationItems?.length - 1; i++) {
                if (this.syndication.syndicationItems[i].id == result.id) {
                  idx = i;
                  break;
                }
              }
              this.syndication.syndicationItems.splice(idx, 1);
              this.dataSource = new MatTableDataSource(this.syndication.syndicationItems);
            }
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.success("Syndication Removed!", $localize`:@@companyName:Rondeivu`);
          }, error: err => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.error("Unable to remove syndication!", $localize`:@@companyName:Rondeivu`);
          }
        });
      }
    });
  }

  showNotes(notes: string) {
    this.dialog.open(NotesModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {notes: notes},
      disableClose: true
    });
  }

  investorIndicateInterest() {
      this.dialog.open(IndicateInterestModalComponent, {
        height: 'auto',
        width: this.util.getModalWidth(ModalSize.MEDIUM),
        maxWidth: '800px',
        data: {},
        disableClose: true
      })
      .afterClosed().subscribe((result: any) => {
        console.log("Indicate Interest Dialog output:", result);
        if (!!result) {
          this.store.dispatch(toggleLoading({loading: true}));
          this.syndicationService.indicateInterest(result).subscribe({
            next: (res: any) => {
              this.toastrService.success("Interest Indicated!", $localize`:@@companyName:Rondeivu`);
              this.store.dispatch(toggleLoading({loading: false}));
              this.getSyndication();
              
            }, error: err => {
              this.store.dispatch(toggleLoading({loading: false}));
              this.toastrService.error("Unable to indicate interest!", $localize`:@@companyName:Rondeivu`);
            }
          });
        }
      });
  }

  /**
   * Opens the sub doc modal
   * @param element
   */
  openSubdocModal(element: ISyndicationItem) {
    const delRef = this.dialog.open(DealSubscriptionSubdocModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {
        businessUnitId: element.investor.id,
        subscriptionId: element.id,
        amount: element.allocationAmount
      },
      disableClose: true
    });

    delRef.afterClosed().subscribe(result => {
      if (!!result) {
        this.getSyndication();
      }
    });
  }

  /**
   * Edit the sub doc
   * @param element
   */
  editSubdoc(element: ISyndicationSubdoc) {
    console.log("Edit subdoc", element);
    // get the data and inject it into the
    this.store.dispatch(toggleLoading({loading: true}));
      this.subDocService.getDocumentFields(element.id).subscribe({
        next: (fields: ISubDocFieldsResponse) => {
          this.store.dispatch(toggleLoading({loading: false}));

          this.dialog.open(DealSubscriptionSubdocEditModalComponent, {
            height: 'auto',
            width: 'auto',
            data: {
              subdoc: element
            },
            disableClose: true
          }).
          afterClosed().subscribe(result => {
            if (!!result) {
              this.getSyndication();
            }
          });

        }, error: err => {
          this.store.dispatch(toggleLoading({loading: false}));
          this.toastrService.error("Unable to get fields!", $localize`:@@companyName:Rondeivu`);
        }
      });
  }

  downloadSubdoc(element: ISyndicationSubdoc) {
    this.store.dispatch(toggleLoading({loading: true, message: "This operation may take a few seconds!"}));
    this.subDocService.getSubdocPdf(element.id).subscribe({
      next: (res: Blob) => {
        let dt = element.subscriptionDate.split('T')[0];
        let filename = element.entityName + '-' + dt + '.pdf';
        let blob: Blob = res as Blob;
        let a = document.createElement('a');
        a.download = filename;
        a.href = window.URL.createObjectURL(blob);
        a.click();
        this.store.dispatch(toggleLoading({loading: false}));
      },
      error: (err: any) => {
        this.store.dispatch(toggleLoading({loading: false}));
        this.toastrService.error("Unable to download file!", $localize`:@@companyName:Rondeivu`);
      }
    });
  }

  // This is for the investors to fill the subdoc
  fillSubdoc(element: ISyndicationSubdoc, isRondeivu: boolean) {
    // get the data and inject it into the
    this.store.dispatch(toggleLoading({loading: true, message: "This may take a few seconds!" }));
      this.subDocService.getDocumentFields(element.id).subscribe({
        next: (fields: ISubDocFieldsResponse) => {
          this.store.dispatch(toggleLoading({loading: false}));

          this.dialog.open(DealSubscriptionSubdocFormModalComponent, {
            height: 'auto',
            width: 'auto',
            minWidth: '900px',
            data: {
              fields: fields,
              isRondeivu: isRondeivu
            },
            disableClose: true
          }).
          afterClosed().subscribe(result => {
            if (!!result) {
              this.getSyndication();
            }
          });

        }, error: err => {
          this.store.dispatch(toggleLoading({loading: false}));
          this.toastrService.error("Unable to get fields!", $localize`:@@companyName:Rondeivu`);
        }
      });
  }


  /**
   * Delete the sub doc
   * @param element
   */
  deleteSubdoc(element: ISyndicationSubdoc) {
    this.dialog.open(DeleteConfirmationModalComponent, {
      height: 'auto',
      width: 'auto',
      data: {
        subdoc: element
      }
    })
    .afterClosed().subscribe(result => {
      if (!!result) {
        let id = result.subdoc.id;
        this.store.dispatch(toggleLoading({loading: true}));
        this.subDocService.deleteSubdoc(id).subscribe({
          next: (res: any) => {
            this.getSyndication();
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.success("Sub Doc Removed!", $localize`:@@companyName:Rondeivu`);
          }, error: err => {
            this.store.dispatch(toggleLoading({loading: false}));
            this.toastrService.error("Unable to remove sub doc!", $localize`:@@companyName:Rondeivu`);
          }
        });
      }
    });
  }
}
